export function intercomCatchErrorMessage(error: any) {
    return `Error: ${error?.response?.data?.message}`
}